<template>
  <div class="mainContent lightBlue haslogin">
    <div class="w1200 conTop mt10 mb25 has-cloud" v-if="false">
      <div class="fl advert mr10 borderRadius">
        <a>
          <img src="../../assets/images/banner/stem_banner.png" />
        </a>
      </div>
      <!--没有登录的时候显示-->
      <div class="mineInfor fl borderRadius" v-if="!isLogin">
        <div class="topBox">
          <div class="header">
            <img src="../../assets/images/common/default.png" />
          </div>
        </div>
        <div class="bottomBox">
          <div class="mx-auto my-2 text-lg center">
            点击下方“登录”，
            <br />
            查看更多课程内容哦~
          </div>
          <p class="flex justify-center mx-auto center">
            <router-link to="/login">
              <button class="text-white bg-yellow-400 border">登录</button>
            </router-link>
            <router-link :to="`/register?v=${Math.random() * 100000000000000000 }`">
              <button class="bg-gray-300 border">注册</button>
            </router-link>
          </p>
        </div>
      </div>
      <!--登录的时候显示-->
      <div class="mineInfor fl borderRadius center" v-if="isLogin">
        <div class="topBox">
          <div class="header">
            <img src="../../assets/images/common/default.png" />
          </div>
        </div>
        <div class="bottomBox">
          <div class="center mb5">
            <!-- 激活课程数据，暂时不需要 -->
            <p class="userName">欢迎您, {{ userName }}</p>
          </div>
          <router-link to="/ucenter/index">
            <span class="inline-block px-8 py-2 my-5 text-white bg-yellow-500 rounded-lg">个人中心</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="p-5 bg-white rounded-md menu-select w1200 mt-6">
      <!-- <MyButtonRadio :list="gradeList" title="年级" @selected="getSelectedGrade"></MyButtonRadio>
      <MyButtonRadio :list="sujectList" title="学科" @selected="getSelectedSubject"></MyButtonRadio>
      <MyButtonRadio :list="periodList" title="学期" @selected="getSelectedPeriod"></MyButtonRadio> -->
      <div class="flex justify-center">
        <!-- <span class="inline-block my-2 center" style="width: 72px">名称：</span> -->
        <input type="text" v-model="keyword" class="px-2 mx-2 border w-100 h-12 rounded outline-light-50  focus:outline-none focus:ring-2 text-lg focus:ring-green-100 border-gray-300" placeholder="请输入课程名称关键字" />
        <button class="px-12 py-1 mx-4 text-lg text-white bg-[#34da85] rounded hover:bg-green-600" @click="doSearch">搜索</button>
      </div>
    </div>
    <div class="w1200 title-and-seperator mt-4">
      <p class="text-gray-900 totalNum">
        当前课程共有
        <!-- <i class="text-yellow-500">{{ curShowList.length }}</i> -->
        <i class="text-yellow-500">{{ totalNum }}</i>
        门
      </p>
    </div>
    <div class="flex flex-wrap justify-between course-list-section w1200">
      <!-- <CourseItem v-for="item of list" :key="item.id" :info="item" v-show="item.id==78|| item.id==79||item.id==80"/> -->
      <!-- <CourseItem v-for="item of list" :key="item.id" :info="item" /> -->
      <CourseItem v-for="item of list" :key="item.id" :info="item" />
    </div>
    <div class="flex justify-end mt-20 w1200">
      <el-pagination background :page-size="9" :current-page="currentPageNum" layout="prev, pager, next" :total="totalNum" @current-change="pageChange"></el-pagination>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import CommonUtils from "../../utils/CommonUtils";
import MyButtonRadio from "../../components/MyButtonRadio.vue";
import CourseItem from "./CourseItem.vue";
import { ElPagination } from "element-plus";
import CourseService from "../../apis/CourseService";
import Constants from "../../constants/Index";
import MittUtil from "../../utils/MittUtil";
import { curShowList } from "./curShowList";
const list = ref(null);
const isLogin = ref(false);
const userName = ref("");
const selectedGrade = ref(99);
const selectSubject = ref(99);
const selectedPeriod = ref(99);
const totalNum = ref(0);
const currentPageNum = ref(1);
const keyword = ref();

const gradeList = ref([
  { id: 99, text: "不限" },
  { id: 1, text: "一年级" },
  { id: 2, text: "二年级" },
  { id: 3, text: "三年级" },
  { id: 4, text: "四年级" },
  { id: 5, text: "五年级" },
  { id: 6, text: "六年级" },
  { id: 7, text: "七年级" },
  { id: 8, text: "八年级" },
  { id: 9, text: "九年级" },
]);
const sujectList = ref([
  { id: 99, text: "不限" },
  { id: 1, text: "语文" },
  { id: 2, text: "数学" },
  { id: 3, text: "英语" },
  { id: 4, text: "科学" },
  { id: 5, text: '道德与法治' },
  { id: 6, text: '历史与社会' },
]);
const periodList = ref([
  { id: 99, text: "不限" },
  { id: 1, text: "上学期" },
  { id: 2, text: "下学期" },
]);

const showHandle = (item: any) => {
  console.log("=============is show course item");
  curShowList.forEach((c: any) => {
    return c.id == item.id;
  })
};

const getSelectedGrade = (item: any) => {
  console.log(item);
  selectedGrade.value = item.id;
};
const getSelectedSubject = (item: any) => {
  selectSubject.value = item.id;
};
const getSelectedPeriod = (item: any) => {
  selectedPeriod.value = item.id;
};

// pageNum:string,
// pageSize: string,
// grade: string,
// course: string,
// term: string,
// name:string,
const getList = (pageNum: number | string, pageSize: string | number, grade?: string | number, course?: string | number, term?: string | number, name?: string) => {
  const postData = {
    pageNum,
    pageSize,
    name,
  };
  if (grade != 99) {
    postData.grade = grade;
  }
  if (course != 99) {
    postData.course = course;
  }
  if (term != 99) {
    postData.term = term;
  }
  //@ts-ignore
  CourseService.getList(postData).then((res) => {
    if (res.code == 1) {
      list.value = res.data && res.data.list;
      totalNum.value = res.data && res.data.total;
      currentPageNum.value = pageNum as number;
    }
  });
};
//监听登录状态
MittUtil.on("isLogin", (e) => {
  isLogin.value = e;
});
onMounted(() => {
  if (CommonUtils.isLogin()) {
    isLogin.value = true;
    userName.value = CommonUtils.getLocalStore(Constants.NickNamekey);
  }
  getList(1, 9);
});

const doSearch = () => {
  getList(1, 9, selectedGrade.value, selectSubject.value, selectedPeriod.value, keyword.value);
};
//分页事件
const pageChange = (num: any) => {
  getList(num, 9, selectedGrade.value, selectSubject.value, selectedPeriod.value, keyword.value);
};
</script>
<style lang="scss">
.course-list-section {
  &::after {
    content: "";
    width: 32%;
    display: block;
    height: auto;
  }
}
.title-and-seperator {
  .totalNum {
    height: 72px;
    width: 176px;
    line-height: 72px;
    padding-left: 17px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMCAYAAACqYHctAAAAAXNSR0IArs4c6QAAAEVJREFUCB1j/J+a6snAwDCL4f9/GSD9mIGRMZ0JSQDIZJAFSs5kgqoACcCALBNQ+RMYD0o/BmlPQ5IAm4mmCA+XkV5OAgCjniQ3TG2KRgAAAABJRU5ErkJggg==) no-repeat 6px;
    background-size: auto 10px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 1000px;
      height: 0;
      left: 100%;
      top: 50%;
      border-bottom: 1px solid #ffffff;
    }
  }
}
.mainContent:after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 700px;
  background: url("../../assets/images/common/bg_di.png") no-repeat 0 bottom;
  background-size: 100% auto;
}
.mainContent:before {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  right: 150px;
  width: 10%;
  height: 100px;
  z-index: 3;
  // background: url("../../assets/images/common/img_qxz.png") no-repeat 0 top;
  background-size: auto 100%;
}
.mainContent {
  padding-bottom: 175px;
}
.conTop {
  height: 363px;
  .advert {
    width: 890px;
    height: 350px;
    border-radius: 4px;
  }
  .mineInfor {
    width: 300px;
    height: 100%;
    background: url("../../assets/images/index/bg_login.png") no-repeat;
    background-size: 100% 100%;
    .topBox {
      height: 50%;
      position: relative;
    }
    .bottomBox {
      height: 50%;
      line-height: 30px;
      padding-top: 30px;
      box-sizing: border-box;
      font-size: 20px;
    }
    .header {
      height: 70px;
      width: 70px;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    button {
      width: 100px;
      height: 40px;
      border-radius: 20px;
      margin: 0 10px;
      font-size: 18px;
    }
  }
}

//banner
.advert {
  position: relative;
  ul,
  li {
    height: 100%;
  }
  ul li img {
    width: 100%;
    height: 100%;
  }
  .toLeft,
  .toRight {
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -34px;
    width: 46px;
    height: 68px;
    cursor: pointer;
    display: none;
  }
  .toLeft {
    background: url("../../assets/images/index/btn_jt_left.png") no-repeat;
    left: 15px;
  }
  .toRight {
    background: url("../../assets/images/index/btn_jt_right.png") no-repeat;
    right: 15px;
  }
  .bannerBtns {
    position: absolute;
    bottom: 17px;
    left: 50%;
    transform: translateX(-50%);
  }
  .bannerBtns span {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 8px;
    cursor: pointer;
  }
  .bannerBtns span.ac {
    background-color: #fff;
  }
}

//登录的时候显示
.loginShow.mineInfor {
  .header {
    position: static;
    display: inline-block;
    transform: translate(0, 0);
    margin-top: 42px;
  }
  .header img {
    width: 100%;
    height: 100%;
  }
  .userName {
    font-size: 16px;
    color: #fff;
    line-height: 36px;
  }
  a {
    display: inline-block;
    height: 46px;
    border-radius: 23px;
    width: 240px;
    line-height: 46px;
  }
}
.gradeList {
  background-color: #c8fbff;
  border-radius: 16px;
}
.gradeList .gradeLi.loginShow {
  .listBook li {
    width: 170px;
    margin-right: 45px;
    padding-top: 0;
    box-shadow: none;
    img {
      width: 100%;
    }
  }
  .listBook li:last-of-type {
    margin-right: 0;
  }
  .listBook .hasNoData {
    background: url("../../assets/images/index/img_zy_nokc.png") no-repeat top center;
    background-size: auto 200px;
    padding: 200px 0 0;
    width: 100%;
    p {
      line-height: 60px;
      height: 60px;
      text-align: center;
      font-size: 24px;
    }
  }
}

.studySection {
  background-color: #91e6ec;
  padding: 35px 0;
  text-align: center;
  ul {
    display: inline-block;
  }
  ul li {
    width: 130px;
    .picBox {
      width: 60px;
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      margin: 0 auto;
      border-radius: 50%;
      border: 4px #fff solid;
      /* background-color: #6094eb;*/
    }
    .learn1 {
      background: url("../../assets/images/index/bg_yw.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn2 {
      background: url("../../assets/images/index/bg_sx.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn3 {
      background: url("../../assets/images/index/bg_yy.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn4 {
      background: url("../../assets/images/index/bg_kx.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn5 {
      background: url("../../assets/images/index/bg_js.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn6 {
      background: url("../../assets/images/index/bg_tzxkc.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn7 {
      background: url("../../assets/images/index/bg_xxkc.png") no-repeat;
      background-size: 100% 100%;
    }
    p {
      line-height: 28px;
    }
  }
}
.unlogin {
  .unloginShow {
    display: block;
  }
  .loginShow {
    display: none;
  }
}
.haslogin {
  .unloginShow {
    display: none;
  }
  .loginShow {
    display: block;
  }
}
.layui-layer {
  border-radius: 18px;
  font-size: 16px;
  .layui-layer-title {
    text-align: center;
    padding: 0;
    background-color: #2bb9c3;
    height: 38px;
    line-height: 38px;
    color: #fff;
    font-size: 16px;
    border: 0;
  }
  .layui-layer-btn {
    text-align: center;
    margin-bottom: 40px;
    padding: 0;
    a {
      width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 3px;
      margin: 0 15px;
      padding: 0;
      border: 0;
    }
    .layui-layer-btn0 {
      background-color: #dedede;
      color: #646464;
    }
    .layui-layer-btn1 {
      background-color: #1f920c;
      color: #fff;
    }
  }
  .layui-layer-setwin {
    top: 11px;
    .layui-layer-close1 {
      background: url("../../assets/images/common/btn_tc_close.png") no-repeat;
    }
  }
}
.layui-layer.layalert .layui-layer-content {
  height: 110px;
  .noticeFont {
    background: url("../../assets/images/common/alert_icon.png") no-repeat;
    background-size: auto 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 210px;
    transform: translate(-50%, -50%);
  }
}
.layui-layer.layalert .layui-layer-btn a:last-of-type {
  background-color: #1f920c;
  color: #fff;
}
</style>
